module.exports = __webpack_public_path__ + "static/img/3.eb9eff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/3.png
// module id = fP5Q
// module chunks = 1